import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { TIMELINE } from '../../../../../packages/constants/widgetIds';

// TODO: Review prefilled attributes; some of them might not be applicable to this widget
export const timelineAttributes = getWidgetAttributes(
  TIMELINE,
  // Required attributes:
  [WidgetAttributes.WIDGET_ID, WidgetAttributes.WIDGET_SPORT, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.MATCH],
  // Optional attributes:
  [
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.LABELS,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.THEME,
  ],
);
